import { render, staticRenderFns } from "./home-table.vue?vue&type=template&id=55cf72f5&"
import script from "./home-table.vue?vue&type=script&lang=ts&"
export * from "./home-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports